<template>
  <div>
    <template v-if="fluxoAtual">
      <v-tooltip right>
        <template v-slot:activator="{ attrs, on }">
          <span v-bind="attrs" class="align-center d-inline-flex mt-3" v-on="on">
            <span class="caption grey--text mr-2">Fluxo definido:</span>
            <span class="align-center caption d-inline-flex font-weight-medium primary--text">
              {{ fluxoAtual.label }}
              <v-icon class="ml-1" color="primary" size="15" style="margin-top: 2px">mdi-information-outline</v-icon>
            </span>
          </span>
        </template>
        <span class="d-inline-block" style="max-width: 360px">{{ fluxoAtual.descricao }}</span>
      </v-tooltip>

      <div class="chart-flow__content mt-8">
        <div class="chart-flow__steps">
          <div v-for="(etapa, index) in etapas" :key="etapa.id" class="align-center chart-flow__step d-flex flex-column">
            <span
              class="align-center chart-flow__indicator d-inline-flex justify-center"
              :class="'chart-flow__indicator--' + estadoEtapa(index)"
            >
              <v-icon size="16">{{ iconeEtapa(index) }}</v-icon>
            </span>

            <span class="caption mt-2 text-center" :class="classeRotuloEtapa(index)">
              {{ etapa.label }}
            </span>

            <span
              v-if="index < etapas.length - 1"
              class="chart-flow__connector"
              :class="'chart-flow__connector--' + estadoEtapa(index)"
            />
          </div>
        </div>
      </div>
    </template>

    <div v-else class="align-center d-flex grey--text mt-3" style="min-height: 109px">
      <v-icon class="mr-2" color="grey" small>mdi-information-outline</v-icon>
      <span class="body-2">O fluxo será definido ao concluir a tarefa de encaminhamento.</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ChartFlow',

    props: {
      currentFlow: {
        type: String,
        default: null
      },
      currentStep: {
        type: String,
        default: ''
      },
      currentTask: {
        type: String,
        default: ''
      },
      flows: {
        type: Array,
        required: true
      },
      value: {
        type: String,
        default: null
      }
    },

    computed: {
      fluxoSelecionado() {
        return this.currentFlow || this.value || (this.flows[0] && this.flows[0].id);
      },

      fluxo() {
        return this.flows.find((fluxo) => fluxo.id === this.fluxoSelecionado) || { steps: [] };
      },

      fluxoAtual() {
        return this.flows.find((fluxo) => fluxo.id === this.currentFlow) || null;
      },

      etapas() {
        return this.fluxo.steps.map((etapa, index, etapas) => ({
          ...etapa,
          ordem: index + 1,
          proximaEtapa: etapas[index + 1] || null
        }));
      },

      indiceEtapaAtual() {
        if (this.currentFlow && this.currentFlow !== this.fluxoSelecionado) return -1;

        const status = String(this.currentStep || '').toUpperCase();

        if (status === 'ENCERRADO') {
          return this.etapas.findIndex((etapa) => etapa.statuses.includes(status));
        }

        const tarefa = String(this.currentTask || '').toUpperCase();
        const indiceTarefaAtual = this.etapas.findIndex((etapa) => etapa.tarefa === tarefa);

        if (indiceTarefaAtual >= 0) return indiceTarefaAtual;

        return this.etapas.findIndex((etapa) => etapa.statuses.includes(status));
      }
    },

    methods: {
      estadoEtapa(index) {
        if (this.indiceEtapaAtual < 0) return 'bloqueada';
        if (index < this.indiceEtapaAtual) return 'concluida';
        if (index === this.indiceEtapaAtual) {
          return String(this.currentStep || '').toUpperCase() === 'ENCERRADO' ? 'concluida' : 'atual';
        }

        return 'bloqueada';
      },

      iconeEtapa(index) {
        const estado = this.estadoEtapa(index);

        if (estado === 'concluida') return 'mdi-check';
        if (estado === 'atual') return 'mdi-play';

        return 'mdi-lock-outline';
      },

      classeRotuloEtapa(index) {
        return {
          'font-weight-bold primary--text': this.estadoEtapa(index) === 'atual',
          'grey--text text--lighten-1': this.estadoEtapa(index) === 'bloqueada'
        };
      }
    }
  };
</script>

<style scoped>
  .chart-flow__content {
    overflow-x: auto;
  }

  .chart-flow__steps {
    display: flex;
    min-width: 660px;
  }

  .chart-flow__step {
    flex: 1 1 0;
    min-width: 120px;
    position: relative;
  }

  .chart-flow__indicator {
    background: #fff;
    border: 2px solid #bcbcbc;
    border-radius: 50%;
    color: #8f969e;
    height: 28px;
    width: 28px;
    z-index: 1;
  }

  .chart-flow__indicator--concluida {
    background: #95c994;
    border-color: #95c994;
    color: #fff;
  }

  .chart-flow__indicator--atual {
    background: #eee3f5;
    border-color: #6200a8;
    color: #6200a8;
  }

  .chart-flow__connector {
    background: #cfcfcf;
    height: 2px;
    left: calc(50% + 14px);
    position: absolute;
    top: 13px;
    width: calc(100% - 28px);
    z-index: 0;
  }

  .chart-flow__connector--concluida {
    background: #95c994;
  }
</style>
